import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { carecentreTypeScale as type } from "../../typeScale";
import CcFieldLayout, {
  resolveFieldMessage,
  useCcInputStyles,
} from "./CcFieldLayout";

const zen = {
  primary: "#0765FF",
  lineStrong: "#CAC7BE",
  text: "#15191F",
};

const useStyles = makeStyles(() => ({
  group: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 18,
    margin: 0,
  },
  option: {
    margin: 0,
    color: zen.text,
    "& .MuiFormControlLabel-label": {
      fontSize: type.body.fontSize,
      lineHeight: `${type.body.lineHeight}px`,
    },
  },
  radio: {
    color: zen.lineStrong,
    padding: 6,
    "&.Mui-checked": {
      color: zen.primary,
    },
  },
}));

const CcRadioGroup = ({
  label,
  required = false,
  options = [],
  value,
  onChange,
  name,
  error,
  helperText,
  hint,
  row = true,
  className,
  ...props
}) => {
  const classes = useStyles();
  const inputClasses = useCcInputStyles();
  const { hasError, message } = resolveFieldMessage({
    error,
    helperText,
    hint,
  });

  const group = (
    <RadioGroup
      className={classes.group}
      row={row}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      {...props}
    >
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          className={classes.option}
          value={String(option.value)}
          control={<Radio className={classes.radio} />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );

  if (!label && !message) {
    return <div className={inputClasses.root}>{group}</div>;
  }

  return (
    <CcFieldLayout
      label={label}
      required={required}
      error={hasError ? message : undefined}
      hint={!hasError ? message : undefined}
      className={className}
    >
      {group}
    </CcFieldLayout>
  );
};

export default CcRadioGroup;
